/* Skrubbhuset – fri frakt-mätare och paketuppgradering i varukorgen (v8)
   - Paket som varianter (värden som börjar med en siffra): byter till nästa paket.
   - Paket med blandade färger + automatiska rabatter (raden rabatt= i SH – Varukorg):
     föreslår en till av vald produkt, med priset uträknat från rabatterna i kundens valuta.
   - Rekommenderar vald produkt när den inte ligger i varukorgen. */
(function () {
  var dataEl = document.getElementById('sh-cart-boost-data');
  if (!dataEl) return;
  var cfg;
  try { cfg = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var T = cfg.t || {};
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || cfg.currency || 'SEK';
  var rate = parseFloat((window.Shopify && Shopify.currency && Shopify.currency.rate) || '1') || 1;
  var wholeOnly = ['SEK', 'DKK', 'NOK', 'ISK'].indexOf(currency) !== -1;
  var loc = (cfg.numLocale || 'sv-SE').slice(0, 2);
  var TB = {
    sv: { up: 'Uppgradera till {v}', yes: 'Ja, uppgradera +{x}', adding: 'Uppgraderar…' },
    da: { up: 'Opgrader til {v}', yes: 'Ja, opgrader +{x}', adding: 'Opgraderer…' },
    en: { up: 'Upgrade to {v}', yes: 'Yes, upgrade +{x}', adding: 'Upgrading…' }
  }[loc] || { up: 'Upgrade to {v}', yes: 'Yes, upgrade +{x}', adding: 'Upgrading…' };
  var busy = false;
  var timer;
  var pcache = {};

  var threshold = Math.round((cfg.thresholdBase || 0) * 100 * rate);
  var shipFee = Math.round((cfg.shipFee || 0) * 100 * (cfg.tiersBase ? rate : 1));
  var tiers = (cfg.tiers || []).map(function (x) {
    return Math.round(x * 100 * (cfg.tiersBase ? rate : 1));
  });

  function money(c, roundUp) {
    if (wholeOnly && c % 100 !== 0 && roundUp) c = Math.ceil(c / 100) * 100;
    var whole = c % 100 === 0;
    try {
      return new Intl.NumberFormat(cfg.numLocale || 'sv-SE', {
        style: 'currency', currency: currency,
        minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2
      }).format(c / 100);
    } catch (e) {
      return (c / 100).toFixed(whole ? 0 : 2) + ' ' + currency;
    }
  }
  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (m) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m];
    });
  }
  function tr(key, vars) {
    var s = T[key] || '';
    Object.keys(vars || {}).forEach(function (k) { s = s.split('{' + k + '}').join(vars[k]); });
    return s;
  }
  function fill(s, vars) {
    Object.keys(vars || {}).forEach(function (k) { s = s.split('{' + k + '}').join(vars[k]); });
    return s;
  }
  function num(s) { var m = String(s == null ? '' : s).match(/^\s*(\d+)/); return m ? parseInt(m[1], 10) : 0; }
  function per(total, k) { return Math.round(total / k); }

  function shipBar(total) {
    if (threshold <= 0) return '';
    if (total >= threshold) {
      return '<div class="shcb__ship shcb__ship--ok"><span class="shcb__ico" aria-hidden="true">✓</span><span>' + tr('ship_ok') + '</span></div>' +
        '<div class="shcb__bar" aria-hidden="true"><div class="shcb__fill" style="width:100%"></div></div>';
    }
    var pct = Math.max(6, Math.min(100, Math.round((total / threshold) * 100)));
    return '<div class="shcb__ship"><span class="shcb__ico" aria-hidden="true">🚚</span><span>' +
      tr('ship_left', { x: '<strong>' + money(threshold - total, true) + '</strong>' }) + '</span></div>' +
      '<div class="shcb__bar" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + pct + '"><div class="shcb__fill" style="width:' + pct + '%"></div></div>';
  }

  function getProduct(handle) {
    if (pcache[handle] !== undefined) return Promise.resolve(pcache[handle]);
    return fetch(root + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { pcache[handle] = p; return p; })
      .catch(function () { pcache[handle] = null; return null; });
  }

  function packIndex(p) {
    if (!p || !p.variants || !p.variants.length) return -1;
    var n = p.variants[0].options.length;
    for (var k = 0; k < n; k++) {
      var all = p.variants.every(function (v) { return num(v.options[k]) > 0; });
      var distinct = {};
      p.variants.forEach(function (v) { distinct[num(v.options[k])] = 1; });
      if (all && Object.keys(distinct).length > 1) return k;
    }
    return -1;
  }

  function offerFor(item, p) {
    var idx = packIndex(p);
    if (idx < 0) return null;
    var cur = null;
    p.variants.forEach(function (v) { if (v.id === item.variant_id) cur = v; });
    if (!cur) return null;
    var curN = num(cur.options[idx]);
    if (!curN) return null;
    var best = null;
    p.variants.forEach(function (v) {
      if (!v.available || v.id === cur.id) return;
      var n = num(v.options[idx]);
      if (n <= curN) return;
      for (var k = 0; k < v.options.length; k++) { if (k !== idx && v.options[k] !== cur.options[k]) return; }
      if (!best || n < num(best.options[idx])) best = v;
    });
    if (!best) return null;
    var q = item.quantity;
    var newN = num(best.options[idx]);
    var add = (best.price - cur.price) * q;
    if (add <= 0) return null;
    var save = Math.max(0, Math.round(cur.price / curN * newN - best.price)) * q;
    var img = (best.featured_image && best.featured_image.src) || item.image || p.featured_image;
    return { from: cur.id, to: best.id, qty: q, label: best.options[idx], add: add, save: save, unitNow: per(cur.price, curN), unitNew: per(best.price, newN), image: img };
  }

  function findBundleOffer(cart) {
    var items = (cart.items || []).filter(function (i) {
      return (i.options_with_values || []).some(function (o) { return num(o.value) > 0; });
    });
    if (!items.length) return Promise.resolve(null);
    return items.reduce(function (chain, item) {
      return chain.then(function (found) {
        if (found) return found;
        return getProduct(item.handle).then(function (p) { return offerFor(item, p); });
      });
    }, Promise.resolve(null));
  }

  function bundleCard(cart, o) {
    var total = cart.total_price;
    var freeShip = threshold > 0 && total < threshold && total + o.add >= threshold;
    var net = freeShip && shipFee > 0 ? Math.max(0, o.add - shipFee) : o.add;
    var headline = net < o.add
      ? tr('net', { x: '<strong>' + money(net) + '</strong>' })
      : tr('only', { x: '<strong>' + money(o.add) + '</strong>' });
    var sub = net < o.add ? tr('net_sub', { x: money(shipFee) }) : (freeShip ? tr('free_order') : '');
    var title = fill(TB.up, { v: o.label });
    var img = o.image ? (String(o.image).indexOf('//') === 0 ? 'https:' + o.image : o.image) : '';
    return '<div class="shcb-up" role="group" aria-label="' + esc(title) + '">' +
      (o.save > 0 ? '<span class="shcb-up__badge">' + esc(tr('save', { x: money(o.save) })) + '</span>' : '') +
      '<div class="shcb-up__row">' +
        (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="64" height="64">' : '') +
        '<div class="shcb-up__info">' +
          '<p class="shcb-up__t">' + esc(title) + '</p>' +
          '<p class="shcb-up__unit"><s>' + money(o.unitNow) + tr('per') + '</s> <span aria-hidden="true">→</span> <strong>' + money(o.unitNew) + tr('per') + '</strong></p>' +
        '</div>' +
      '</div>' +
      '<div class="shcb-up__deal"><p class="shcb-up__net">' + headline + '</p>' +
        (sub ? '<p class="shcb-up__sub">' + esc(sub) + '</p>' : '') + '</div>' +
      '<div class="shcb-up__act">' +
        '<button type="button" class="shcb-up__add" data-from="' + o.from + '" data-to="' + o.to + '" data-qty="' + o.qty + '">' + esc(fill(TB.yes, { x: money(o.add) })) + '</button></div>' +
    '</div>';
  }

  function build(cart, offer) {
    if (!cart || cart.item_count === 0) return '';
    var total = cart.total_price;
    var html = shipBar(total);

    if (offer) return html + bundleCard(cart, offer);

    var p = cfg.product;
    if (!p) return html;
    var avail = p.variants.filter(function (v) { return v.available; });
    if (!avail.length) return html;
    var minP = Math.min.apply(null, avail.map(function (v) { return v.price; }));
    avail = avail.filter(function (v) { return v.price === minP; });

    var qty = 0, firstVariant = null;
    cart.items.forEach(function (i) {
      if (i.handle === p.handle) { qty += i.quantity; if (!firstVariant) firstVariant = i.variant_id; }
    });

    var unit = avail[0].price;
    var options = avail.map(function (v) {
      return '<option value="' + v.id + '"' + (v.id === firstVariant ? ' selected' : '') + '>' + esc(String(v.title).split(' / ')[0]) + '</option>';
    }).join('');
    var picker = avail.length > 1
      ? '<select class="shcb-up__v" aria-label="' + esc(tr('color')) + '">' + options + '</select>'
      : '<input type="hidden" class="shcb-up__v" value="' + avail[0].id + '">';

    if (qty === 0) {
      return html + '<div class="shcb-up shcb-up--plain">' +
        '<div class="shcb-up__row">' +
          (p.image ? '<img src="' + esc(p.image) + '" alt="" loading="lazy" width="64" height="64">' : '') +
          '<div class="shcb-up__info"><p class="shcb-up__t">' + esc(tr('heading')) + '</p>' +
          '<p class="shcb-up__unit"><strong>' + money(unit) + '</strong></p></div>' +
        '</div>' +
        '<div class="shcb-up__act">' + picker +
          '<button type="button" class="shcb-up__add">' + esc(tr('add')) + '</button></div>' +
      '</div>';
    }

    /* Paketpriser: från rabattraden (omräknad som i kassan) eller gamla styckregler */
    var tl = tiers;
    if ((!tl || tl.length < 2) && cfg.discounts && cfg.discounts.length > 1) {
      var r = (cfg.shopCurrency && cfg.shopCurrency !== currency) ? rate : 1;
      tl = cfg.discounts.map(function (d, i) { return unit * (i + 1) - Math.round(d * 100 * r); });
    }
    if (!tl || tl.length < 2 || qty >= tl.length) return html;
    var add = tl[qty] - tl[qty - 1];
    if (add <= 0) return html;
    var n = qty + 1;
    var save = Math.max(0, unit - add);
    var unitNow = per(tl[qty - 1], qty);
    var unitNew = per(tl[qty], n);
    var freeShip = threshold > 0 && total < threshold && total + add >= threshold;
    var net = freeShip && shipFee > 0 ? Math.max(0, add - shipFee) : add;
    var proof = (qty === 1 && T.proof) ? T.proof : '';
    var headline = net < add
      ? tr('net', { x: '<strong>' + money(net) + '</strong>' })
      : tr('only', { x: '<strong>' + money(add) + '</strong>' });
    var sub = net < add ? tr('net_sub', { x: money(shipFee) }) : (freeShip ? tr('free_order') : '');
    html += '<div class="shcb-up" role="group" aria-label="' + esc(tr('upgrade', { n: n })) + '">' +
      (save > 0 ? '<span class="shcb-up__badge">' + esc(tr('save', { x: money(save) })) + '</span>' : '') +
      '<div class="shcb-up__row">' +
        (p.image ? '<img src="' + esc(p.image) + '" alt="" loading="lazy" width="64" height="64">' : '') +
        '<div class="shcb-up__info">' +
          '<p class="shcb-up__t">' + esc(tr('upgrade', { n: n })) + '</p>' +
          '<p class="shcb-up__unit"><s>' + money(unitNow) + tr('per') + '</s> <span aria-hidden="true">→</span> <strong>' + money(unitNew) + tr('per') + '</strong></p>' +
        '</div>' +
      '</div>' +
      '<div class="shcb-up__deal"><p class="shcb-up__net">' + headline + '</p>' +
        (sub ? '<p class="shcb-up__sub">' + esc(sub) + '</p>' : '') + '</div>' +
      (proof ? '<p class="shcb-up__proof"><span aria-hidden="true">★★★★★</span> ' + esc(proof) + '</p>' : '') +
      '<div class="shcb-up__act">' + picker +
        '<button type="button" class="shcb-up__add">' + esc(tr('yes', { n: n, x: money(add) })) + '</button></div>' +
    '</div>';
    return html;
  }

  function host() {
    var d = document.querySelector('cart-drawer');
    return d ? d.querySelector('cart-drawer-items') : null;
  }

  function mount(cart, offer) {
    var h = host();
    if (!h) return;
    var html = build(cart, offer);
    var box = document.getElementById('shcb');
    if (!html) { if (box) box.remove(); return; }
    if (!box || !h.contains(box)) {
      if (box) box.remove();
      box = document.createElement('div');
      box.id = 'shcb';
      box.className = 'shcb';
      h.insertBefore(box, h.firstChild);
    }
    if (box.getAttribute('data-k') !== html) {
      box.innerHTML = html;
      box.setAttribute('data-k', html);
    }
  }

  function refresh() {
    if (busy) return;
    busy = true;
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        return findBundleOffer(c).then(function (o) { busy = false; mount(c, o); });
      })
      .catch(function () { busy = false; });
  }

  function soon() { clearTimeout(timer); timer = setTimeout(refresh, 150); }

  function onlyOurs(m) {
    var box = document.getElementById('shcb');
    if (box && box.contains(m.target)) return true;
    var nodes = Array.prototype.slice.call(m.addedNodes).concat(Array.prototype.slice.call(m.removedNodes));
    return nodes.length > 0 && nodes.every(function (n) { return n.id === 'shcb'; });
  }

  function afterChange(drawer, res, variantId) {
    if (drawer && drawer.renderContents && res.sections) {
      res.id = variantId;
      drawer.renderContents(res);
    } else {
      window.location.href = root + 'cart';
      return;
    }
    if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sh-cart-boost' });
    }
    soon();
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.shcb-up__add');
    if (!btn) return;
    var drawer = document.querySelector('cart-drawer');
    var sections = drawer && drawer.getSectionsToRender
      ? drawer.getSectionsToRender().map(function (s) { return s.id; })
      : [];
    var label = btn.textContent;

    if (btn.hasAttribute('data-to')) {
      var from = btn.getAttribute('data-from'), to = Number(btn.getAttribute('data-to')), q = Number(btn.getAttribute('data-qty')) || 1;
      var updates = {}; updates[from] = 0; updates[to] = q;
      btn.disabled = true; btn.textContent = TB.adding;
      fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates, sections: sections, sections_url: window.location.pathname })
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) { btn.disabled = false; btn.textContent = label; return; }
          afterChange(drawer, res, to);
        })
        .catch(function () { btn.disabled = false; btn.textContent = label; });
      return;
    }

    var box = document.getElementById('shcb');
    var input = box && box.querySelector('.shcb-up__v');
    if (!input) return;
    btn.disabled = true;
    btn.textContent = tr('adding');
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(input.value), quantity: 1 }], sections: sections, sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { btn.disabled = false; btn.textContent = label; return; }
        afterChange(drawer, res, Number(input.value));
      })
      .catch(function () { btn.disabled = false; btn.textContent = label; });
  });

  function init() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      new MutationObserver(function (muts) {
        if (muts.every(onlyOurs)) return;
        soon();
      }).observe(drawer, { childList: true, subtree: true });
    }
    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, soon);
    }
    refresh();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
